// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Skeletons de contenu (Assistance, Mentions) : brique shimmer commune + variantes. */
.cskel {
  display: block;
  border-radius: 6px;
  background-color: #e6e8eb;
  background-image: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.65),
    transparent
  );
  background-size: 200% 100%;
  background-repeat: no-repeat;
  background-position: -150% 0;
  animation: cskel-shimmer 1.4s ease-in-out infinite;
}
@keyframes cskel-shimmer {
  to {
    background-position: 150% 0;
  }
}

.cskel-line {
  height: 1.2rem;
  width: 100%;
  margin-bottom: 0.9rem;
}
.cskel-line--short {
  width: 55%;
}
.cskel-title {
  height: 2rem;
  width: 50%;
  margin-bottom: 1.4rem;
}

/* ── Guides : cartes. Rendu dans .guides-container (grille 3 col) -> display:contents
   pour que les cartes skeleton deviennent des items de la grille parente. ──── */
.cskel-guides {
  display: contents;
}
.cskel-guide-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 2rem;
}
.cskel-media {
  width: 100%;
  max-width: 480px;
  aspect-ratio: 16 / 9;
  border-radius: 10px;
  margin: 1.4rem 0;
}
.cskel-btn {
  height: 3.2rem;
  width: 28rem;
  max-width: 100%;
  border-radius: 8px;
}

/* ── FAQ : accordeon. ─────────────────────────────────────────────────────── */
.cskel-faq {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.cskel-faq-header {
  height: 1.8rem;
  width: 30%;
  margin: 1.5rem 0 0.5rem;
}
.cskel-faq-q {
  height: 4.6rem;
  border-radius: 8px;
}

/* ── Tickets : lignes. ────────────────────────────────────────────────────── */
.cskel-tickets {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.cskel-ticket-row {
  display: grid;
  grid-template-columns: 12rem 1fr 14rem;
  gap: 1.5rem;
  align-items: center;
  padding: 1.4rem 1.6rem;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.cskel-ticket-status {
  height: 2.4rem;
  border-radius: 999px;
}
.cskel-ticket-main {
  height: 1.6rem;
}
.cskel-ticket-date {
  height: 1.4rem;
}

/* ── Rich text : blocs de paragraphes. ────────────────────────────────────── */
.cskel-richtext {
  display: flex;
  flex-direction: column;
  gap: 2.2rem;
}
.cskel-rt-block {
  display: flex;
  flex-direction: column;
}
.cskel-rt-h {
  height: 1.8rem;
  width: 40%;
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/composants/Skeleton/ContentSkeleton.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB;;;;;GAKC;EACD,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,kDAAkD;AACpD;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;AAEA;iFACiF;AACjF;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;EACd,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;AACrB","sourcesContent":["/* Skeletons de contenu (Assistance, Mentions) : brique shimmer commune + variantes. */\n.cskel {\n  display: block;\n  border-radius: 6px;\n  background-color: #e6e8eb;\n  background-image: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.65),\n    transparent\n  );\n  background-size: 200% 100%;\n  background-repeat: no-repeat;\n  background-position: -150% 0;\n  animation: cskel-shimmer 1.4s ease-in-out infinite;\n}\n@keyframes cskel-shimmer {\n  to {\n    background-position: 150% 0;\n  }\n}\n\n.cskel-line {\n  height: 1.2rem;\n  width: 100%;\n  margin-bottom: 0.9rem;\n}\n.cskel-line--short {\n  width: 55%;\n}\n.cskel-title {\n  height: 2rem;\n  width: 50%;\n  margin-bottom: 1.4rem;\n}\n\n/* ── Guides : cartes. Rendu dans .guides-container (grille 3 col) -> display:contents\n   pour que les cartes skeleton deviennent des items de la grille parente. ──── */\n.cskel-guides {\n  display: contents;\n}\n.cskel-guide-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 2rem;\n}\n.cskel-media {\n  width: 100%;\n  max-width: 480px;\n  aspect-ratio: 16 / 9;\n  border-radius: 10px;\n  margin: 1.4rem 0;\n}\n.cskel-btn {\n  height: 3.2rem;\n  width: 28rem;\n  max-width: 100%;\n  border-radius: 8px;\n}\n\n/* ── FAQ : accordeon. ─────────────────────────────────────────────────────── */\n.cskel-faq {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n.cskel-faq-header {\n  height: 1.8rem;\n  width: 30%;\n  margin: 1.5rem 0 0.5rem;\n}\n.cskel-faq-q {\n  height: 4.6rem;\n  border-radius: 8px;\n}\n\n/* ── Tickets : lignes. ────────────────────────────────────────────────────── */\n.cskel-tickets {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n.cskel-ticket-row {\n  display: grid;\n  grid-template-columns: 12rem 1fr 14rem;\n  gap: 1.5rem;\n  align-items: center;\n  padding: 1.4rem 1.6rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n}\n.cskel-ticket-status {\n  height: 2.4rem;\n  border-radius: 999px;\n}\n.cskel-ticket-main {\n  height: 1.6rem;\n}\n.cskel-ticket-date {\n  height: 1.4rem;\n}\n\n/* ── Rich text : blocs de paragraphes. ────────────────────────────────────── */\n.cskel-richtext {\n  display: flex;\n  flex-direction: column;\n  gap: 2.2rem;\n}\n.cskel-rt-block {\n  display: flex;\n  flex-direction: column;\n}\n.cskel-rt-h {\n  height: 1.8rem;\n  width: 40%;\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
